// Lightweight, email-as-identity client store.
//
// This is *not* an authenticated session. It's a courtesy convenience for
// visitors who have already signed the Declaration or shared a Conscious
// Act — we save their name/email/country in localStorage so subsequent
// forms auto-fill and the Wall's like/share interactions feel personal.
//
// Server lookup endpoint: GET /api/identity/lookup?email=...
import axios from "axios";

const IDENTITY_KEY = "docm.identity.v1";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function loadIdentity() {
  try {
    const raw = localStorage.getItem(IDENTITY_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function saveIdentity(patch) {
  try {
    const cur = loadIdentity() || {};
    const next = { ...cur, ...patch };
    if (next.email) next.email = String(next.email).toLowerCase().trim();
    localStorage.setItem(IDENTITY_KEY, JSON.stringify(next));
    // Notify listeners (header banner, etc.) without a hard reload.
    try { window.dispatchEvent(new CustomEvent("docm:identity-changed", { detail: next })); } catch (_) { /* noop */ }
    return next;
  } catch {
    return loadIdentity() || {};
  }
}

export function clearIdentity() {
  try {
    localStorage.removeItem(IDENTITY_KEY);
    try { window.dispatchEvent(new CustomEvent("docm:identity-changed", { detail: null })); } catch (_) { /* noop */ }
  } catch { /* noop */ }
}

export async function lookupIdentity(email) {
  const e = String(email || "").trim().toLowerCase();
  if (!e || !/.+@.+\..+/.test(e)) return { found: false };
  try {
    const { data } = await axios.get(`${API}/identity/lookup`, { params: { email: e } });
    return data || { found: false };
  } catch {
    return { found: false };
  }
}

export function hasIdentity() {
  const i = loadIdentity();
  return !!(i && i.email);
}
